let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iGnJK")).then(() => parcelRequire('414QG'));